"use client"

import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

export default function AboutInteractive() {
  return (
    <div className='grid lg:grid-cols-2 gap-8'>
      <Card className='border-border/60 shadow-subtle'>
        <CardContent className='pt-6'>
          <div className='space-y-4'>
            <CardTitle className='text-xl'>Our Mission</CardTitle>
            <CardDescription>
              Empower schools with AI-driven analytics that are easy to use, insightful, and trustworthy.
            </CardDescription>
            <ul className='space-y-2 text-sm text-foreground'>
              <li>• Turn complex data into clear insights</li>
              <li>• Help teachers personalize instruction</li>
              <li>• Support evidence-based decisions</li>
            </ul>
          </div>
        </CardContent>
      </Card>

      <Card className='border-border/60 shadow-subtle'>
        <CardHeader className='pb-3'>
          <div className='flex items-center gap-2'>
            <Badge className='bg-[hsl(var(--primary-blue))] text-white'>What drives us</Badge>
          </div>
        </CardHeader>
        <CardContent className='pt-0'>
          <ul className='grid gap-3'>
            {[
              'Privacy-first analytics and secure data practices',
              'Designed with teachers, for everyday classroom impact',
              'Clear visuals that make data understandable at a glance',
            ].map((v) => (
              <li key={v} className='flex items-start gap-3 rounded-lg border border-border p-3 bg-background'>
                <span className='mt-1 inline-block h-2 w-2 rounded-full bg-[hsl(var(--primary-blue))]' />
                <span className='text-sm text-foreground'>{v}</span>
              </li>
            ))}
          </ul>
          <div className='mt-4'>
            <Button variant='outline' asChild>
              <a href='#support'>Get in touch</a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
